import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDown,
  faAngleUp,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import { Link } from 'react-router-dom'

import config from '../../config/config'
import { POI_PATH, EVENT_PATH } from '../../config/routes'
import { slugify, getPoiLabel, getPoiTypeLabelFromPoi } from '../../utils/utils'
import { useLanguage } from '../../contexts/LanguageContext'
import { setFlashMessage } from '../../contexts/WebsiteContext'

const ManagePoiInternalLink = ({
  poiInternalLink,
  handleDelete,
  handleRankingUpdate,
}) => {
  const { t } = useTranslation()
  const { activeLanguage } = useLanguage()
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [poi, setPoi] = useState(null)

  const poiLabel = getPoiLabel(poi, activeLanguage)
  const poiTypeLabel = getPoiTypeLabelFromPoi(poi, activeLanguage)
  const imgSrc =
    poi && poi.mainPhotoId !== 0
      ? `${config.photoUrlSmall}${poi.mainPhotoId}.jpg`
      : config.defaultThumbnail

  const linkPath = poi && poi.isEvent ? EVENT_PATH : POI_PATH

  useEffect(() => {
    const fetchPoi = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}poi/${poiInternalLink.linkedPoi.id}`,
        )
        const fetchedPoi = response.data
        setPoi(fetchedPoi)
      } catch (error) {
        //console.error('Error fetching POI:', error);
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('An error occurred GET POI INTERNAL LINK:', error)
      }
    }

    fetchPoi()
  }, [poiInternalLink.linkedPoi.id, t])

  const handleTrashClick = () => {
    setShowConfirmation(true)
  }

  const handleCloseConfirmation = () => {
    setShowConfirmation(false)
  }

  const handleConfirmDelete = () => {
    handleDelete(poiInternalLink.id)
    setShowConfirmation(false)
  }

  const handleRanking = (direction) => {
    handleRankingUpdate(direction, poiInternalLink.id)
  }

  return (
    <div
      className="link-item green-frame"
      style={{ display: 'flex', marginBottom: '20px', paddingBottom: '10px' }}
    >
      {poi && (
        <>
          <div style={{ marginRight: '10px', width: '200px' }}>
            <img
              src={imgSrc}
              alt={poiLabel}
              style={{ height: '120px', width: '100%', objectFit: 'cover' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <h3>{poiLabel}</h3>
            <p>{poiTypeLabel}</p>
            <span>
              <Link
                to={`${linkPath
                  .replace(':slug', slugify(poiLabel))
                  .replace(':id', poi.id)}`}
                className="btn btn-sm btn-primary"
              >
                {t('SHOW')}
              </Link>
              <Button
                variant="primary"
                className="btn btn-primary btn-sm margin-left-20"
                onClick={handleTrashClick}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
              <Button
                variant="primary"
                className="btn-sm"
                style={{ marginLeft: '10px' }}
                onClick={() => handleRanking('up')}
              >
                <FontAwesomeIcon icon={faAngleUp} />
              </Button>
              <Button
                variant="primary"
                className="btn-sm"
                style={{ marginLeft: '10px' }}
                onClick={() => handleRanking('down')}
              >
                <FontAwesomeIcon icon={faAngleDown} />
              </Button>
            </span>
          </div>
        </>
      )}

      <Modal show={showConfirmation} onHide={handleCloseConfirmation}>
        <Modal.Header closeButton>
          <Modal.Title>{t('CONFIRM_DELETE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('CONFIRM_DELETE_MESSAGE')}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            {t('CANCEL')}
          </Button>
          <Button variant="primary" onClick={handleConfirmDelete}>
            {t('CONFIRM')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default ManagePoiInternalLink
